// Mock data para Marcelo Carvalho Transportes

export const companyInfo = {
  name: 'Marcelo Carvalho Transportes',
  phone: '+351961866068',
  whatsappPhone: '351961866068',
  email: 'marcelotransporteslisboa@gmail.com',
  location: 'Lisboa e Região',
  hours: 'Segunda a Sexta: 08:00 - 18:00 | Sábado: 09:00 - 13:00',
  whatsappMessage: 'Olá, preciso de um orçamento para mudança. Obrigado!',
  videoUrl: 'https://www.youtube.com/embed/VL1Nj7oHxbU',
  facebookUrl: 'https://www.facebook.com/profile.php?id=61584444300983',
  instagramUrl: 'https://www.instagram.com/marcelocarvalho.transportes'
};

export const services = [
  {
    id: 1,
    title: 'Mudanças Domésticas',
    description: 'Mudanças completas com embalamento, transporte e montagem de móveis.',
    icon: 'Home',
    image: 'https://customer-assets.emergentagent.com/job_mudancas-pro/artifacts/luc7nw1b_Gemini_Generated_Image_4zjznq4zjznq4zjz.png',
  },
  {
    id: 2,
    title: 'Mudanças Comerciais',
    description: 'Mudanças de escritórios e espaços comerciais com mínima interrupção.',
    icon: 'Building2',
    image: 'https://customer-assets.emergentagent.com/job_mudancas-pro/artifacts/fdh3dbic_Gemini_Generated_Image_9b4h0f9b4h0f9b4h.png',
  },
  {
    id: 3,
    title: 'Transporte de Móveis',
    description: 'Transporte seguro de móveis e objetos avulsos com proteção completa.',
    icon: 'Package',
    image: 'https://customer-assets.emergentagent.com/job_mudancas-pro/artifacts/y6jxll3w_Gemini_Generated_Image_95ek8y95ek8y95ek.png',
  },
  {
    id: 4,
    title: 'Montagem e Desmontagem',
    description: 'Serviço especializado de montagem e desmontagem de móveis.',
    icon: 'Wrench',
    image: 'https://customer-assets.emergentagent.com/job_mudancas-pro/artifacts/iqw4dcii_Gemini_Generated_Image_agq7l4agq7l4agq7.png',
  },
];

export const benefits = [
  {
    id: 1,
    title: 'Chega de Móveis Danificados',
    description: 'Equipa certificada com 20 anos de experiência. Garantimos o cuidado que os seus bens merecem.',
    icon: 'Users',
  },
  {
    id: 2,
    title: 'Zero Surpresas no Preço',
    description: 'Orçamento transparente e final. Sem taxas ocultas ou custos adicionais de última hora.',
    icon: 'Shield',
  },
  {
    id: 3,
    title: 'Proteção Premium',
    description: 'Material de embalamento profissional com até 20% de desconto. Caixas reforçadas, plástico-bolha, mantas e mais.',
    icon: 'Package2',
  },
  {
    id: 4,
    title: 'Sem Atrasos que Arruinam o Seu Dia',
    description: 'Cumprimos rigorosamente os horários. A sua mudança acontece no dia e hora combinados.',
    icon: 'Clock',
  },
];

export const testimonials = [
  {
    id: 1,
    name: 'Ana Silva',
    location: 'Lisboa',
    rating: 5,
    text: 'Contratei a Marcelo Carvalho para a mudança de Lisboa para Cascais. Pontuais, rápidos e muito cuidadosos. Recomendo!',
  },
  {
    id: 2,
    name: 'João Ferreira',
    location: 'Sintra',
    rating: 5,
    text: 'Serviço impecável! A equipa foi extremamente profissional e cuidadosa com os nossos móveis. Preço justo e transparente.',
  },
  {
    id: 3,
    name: 'Maria Costa',
    location: 'Amadora',
    rating: 5,
    text: 'Mudança de escritório sem stress! Tudo correu perfeitamente, sem danificar nada. Muito satisfeita com o serviço.',
  },
  {
    id: 4,
    name: 'Pedro Santos',
    location: 'Oeiras',
    rating: 5,
    text: 'Profissionais de confiança. Fizeram a mudança do meu apartamento T3 em poucas horas. Altamente recomendável!',
  },
  {
    id: 5,
    name: 'Sofia Rodrigues',
    location: 'Loures',
    rating: 5,
    text: 'Excelente relação qualidade-preço. Equipa simpática, eficiente e cuidadosa. Voltaria a contratar sem dúvida.',
  },
];

export const faqs = [
  {
    id: 1,
    question: 'Quanto tempo demora a receber um orçamento?',
    answer: 'Respondemos em até 1 hora durante o horário comercial. O orçamento é gratuito e sem compromisso.',
  },
  {
    id: 2,
    question: 'Fornecem material de embalamento?',
    answer: 'Sim! Fornecemos caixas, plástico bolha, mantas e todo o material necessário para proteger os seus bens.',
  },
  {
    id: 3,
    question: 'Como funciona o pagamento?',
    answer: 'Aceitamos pagamento em dinheiro, transferência bancária ou MB Way. 50% no início e 50% no final da mudança.',
  },
  {
    id: 4,
    question: 'Fazem mudanças para fora de Lisboa?',
    answer: 'Sim, realizamos mudanças para todo o país. Contacte-nos para orçamento personalizado.',
  },
  {
    id: 5,
    question: 'Posso cancelar ou remarcar a mudança?',
    answer: 'Sim, pode remarcar até 48h antes sem custos. Cancelamentos devem ser comunicados com 72h de antecedência.',
  },
  {
    id: 6,
    question: 'Como garantem a segurança dos meus bens?',
    answer: 'Utilizamos material de embalamento premium, equipa treinada e técnicas especializadas. Todos os móveis e objetos frágeis recebem proteção adequada.',
  },
];

export const steps = [
  {
    id: 1,
    title: 'Contactar',
    description: 'Entre em contacto via WhatsApp ou formulário e receba orçamento em 1 hora.',
    icon: 'MessageCircle',
  },
  {
    id: 2,
    title: 'Avaliação',
    description: 'Avaliamos o volume e agendamos a data ideal para a sua mudança.',
    icon: 'ClipboardCheck',
  },
  {
    id: 3,
    title: 'Mudança',
    description: 'Equipa profissional realiza a mudança com cuidado, segurança e pontualidade.',
    icon: 'Truck',
  },
];
